import styled from 'styled-components';
import { Button, Form } from 'antd';
import { IToken } from 'store/ducks/globalTypes';
import { CloseCircleOutlined } from '@ant-design/icons';

export const StyledContainer = styled('div')<IToken>`
  overflow-y: hidden;
  background: ${(props) => props.token.colorBgLayout};
  margin-left: auto;
  margin-right: auto;
  background-size: cover;
  padding-top: 20px;
  min-height: 100vh;

  .ant-pagination {
    margin: 10px 0;
  }

  .ant-row {
    gap: 10px;
  }

  a button {
    margin-left: 20px;
  }
`;

export const StyledLinkButton = styled(Button)<IToken>`
  padding: unset;
  line-height: inherit;
  margin-right: ${(props) => `${props.token.marginXXS}px`};

  > span {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;

export const StyledButton = styled(Button)<IToken>`
  min-width: 100%;
  margin-top: ${(props) => `${props.token.marginXS}px`};
  border-radius: ${(props) => `${props.token.borderRadiusSM}px !important`};

  span {
    font-size: 14px;
  }
`;

export const StyledFormItem = styled(Form.Item)<IToken>`
  margin-bottom: ${(props) => `${props.token.margin}px`};
  .ant-input-affix-wrapper {
    overflow: visible;
  }

  .ant-input-suffix {
    display: flex;
    svg {
      color: black;
    }
  }

  .ant-input-password-icon {
    cursor: pointer;
  }

  .ant-input,
  .ant-input-affix-wrapper {
    padding: 8px 10px;
    border-radius: ${(props) => `${props.token.borderRadiusSM}px`};
  }

  .ant-col {
    min-width: 100%;
  }
`;

export const FormContainer = styled('div')<IToken>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  background: white;
  padding: 20px 0;
  min-height: 100%;
  border: 1px solid #5a6f94;

  svg {
    color: white;
  }

  > .ant-typography {
    margin: 0;
  }

  .ant-input-search {
    margin: 16px;
    max-width: 160px;
  }

  .ant-row {
    justify-content: space-between;

    a span {
      color: black;
    }
  }

  > .ant-form {
    @media (min-width: 1300px) {
      min-width: 315px;
    }
  }
`;

export const IconContainer = styled('div')<IToken>`
  background: ${(props) => props.token.colorPrimary};
  padding: ${(props) => `${props.token.paddingSM}px`};
  border-radius: 50%;

  > span {
    font-size: ${(props) => `${props.token.fontSizeXL}px`};
    color: ${(props) => props.token.colorPrimaryText};
  }
`;

export const InputForm = styled('div')`
 position: relative,
 margin-bottom: 20px
`;

export const ActiveUsers = styled('div')`
  margin-top: 24px;

  .ant-transfer {
    display: flex;
    flex-direction: row;
    gap: 16px;

    @media (max-width: 1240px) {
      flex-direction: column;
    }
  }

  .ant-transfer-list {
    flex: 1;
    min-width: 0;

    .ant-wave-target {
      border: 1px solid;
    }
  }
`;

export const SubmitContainer = styled('div')`
  width: fit-content;
  margin: auto;
`;
export const CustomWrapper = styled('div')`
  display: flex;
  align-items: center;
`;

export const ViewUsersContainer = styled('span')`
  padding: 10px;
  width: -webkit-fill-available;
  overflow: scroll;
  height: 600px;

  .ant-list-item {
    border-bottom: 1px solid;
  }

  .ant-typography {
    padding: 0;
  }
`;

export const CloseCircleOutlinedIcon = styled(CloseCircleOutlined)`
  margin-left: 8px;
  font-size: 18px;
  color: #ff4d4f;
  cursor: pointer;
`;
export const UsersData = styled('div')`
  margin-bottom: 8px;
`;

export const HeaderRow = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
`;
